import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { NifValidatorDao } from '@app/dao/nif-validator/nif-validator.dao';
import { combineLatest } from 'rxjs';
import { InfoOption } from '../../components/info/info.component';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UserNifCodeExampleComponent } from './user-nif-code-example/user-nif-code-example.component';

export interface DialogData {
  animal: 'panda' | 'unicorn' | 'lion';
}

@Component({
    selector: 'user-nif-code-form',
    templateUrl: './user-nif-code-form.component.html',
    styleUrls: ['./user-nif-code-form.component.scss'],
    standalone: false
})
export class UserNifCodeFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  error = false;
  productType: string;
  optionInfo: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  sessionConsultant: boolean = false;
  isCristalisOrganization: boolean;
  cristalisOrganizationId: number = 251251251;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private attributionDao: AttributionDao,
    public dialog: MatDialog,
    private nifValidatorDao: NifValidatorDao,
  ) {
    super(formConstructor);
  }

  @ViewChild('invalidNifModal') invalidNifModal: PrModalConfirmComponent;

  ngOnInit() {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
    const pledge = this.subscriptionFacade.getPledge();
    this.sessionConsultant =
      !!pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;

    this.subscriptionFacade.initForm(this, {
      ...pledge?.owners[0],
      sessionConsultant: this.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    const { owners } = this.form.value;

    combineLatest(
      owners.map(owner => this.nifValidatorDao.validate(owner.userNifCode)),
    ).subscribe((res: any[]) => {
      if (res.some(r => !r)) {
        this.invalidNifModal.open();
      } else {
        this.submitForm();
      }
    });
  }

  submitForm() {
    this.subscriptionFacade.submitPledge(this);
  }

  onConfirmInvalidNif() {
    this.submitForm();
  }

  onCancelInvalidNif() {
    this.invalidNifModal.close();
  }

  openDialog(): void {
    this.dialog.open(UserNifCodeExampleComponent);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
